/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ lpName: NonNullable<unknown> }} Coinvestments_Share_Manageaccesstitle3Inputs */

const en_coinvestments_share_manageaccesstitle3 = /** @type {(inputs: Coinvestments_Share_Manageaccesstitle3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Manage access for ${i?.lpName}`)
};

/**
* | output |
* | --- |
* | "Manage access for {lpName}" |
*
* @param {Coinvestments_Share_Manageaccesstitle3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_share_manageaccesstitle3 = /** @type {((inputs: Coinvestments_Share_Manageaccesstitle3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Share_Manageaccesstitle3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_share_manageaccesstitle3(inputs)
});
export { coinvestments_share_manageaccesstitle3 as "coInvestments_share_manageAccessTitle" }